import axios from "axios";
const jsonConfig = require("../../Config.json");

const insertIntoCandidateResumeMappingPowerResume = async (payload) => {
    let response = {}

    try {

        const insertIntoCandidateResumeMappingPowerResumeresponse = await axios.post(
            jsonConfig.apiUrl + "createCandidateResumeMappingPowerResume", payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );
        response = insertIntoCandidateResumeMappingPowerResumeresponse.data;

        return Promise.resolve(response)
    }
    catch (error) {
        //    console.error(error);
        return Promise.reject(error)
    }
}

export default insertIntoCandidateResumeMappingPowerResume;